import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    section1: {
      inputType: 'section',
      title: 'Total Exposure',
      span: 'full',
    },
    initialAdvancePlusTotalDrawDisbursed: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Initial Advance + Total Draw Disbursed',
      prefix: '$',
      disabled: true,
      readOnly: true,
    },
    throughDate: {
      inputType: 'text',
      type: 'date',
      title: 'Through Date',
    },
    costOfCapital: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Cost of Capital',
      prefix: '%',
    },
    calculateThroughDate: {
      inputType: 'text',
      type: 'date',
      title: 'Calculate Through Date',
    },
    carryCost: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Carry Cost',
      prefix: '$',
      disabled: true,
      readOnly: true,
    },
    protectiveAdvances: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Protective Advances',
      prefix: '$',
      disabled: true,
      readOnly: true,
    },
    totalExposure: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Total Exposure',
      prefix: '$',
      disabled: true,
      readOnly: true,
    },
    section2: {
      inputType: 'section',
      title: 'Carrying Costs',
      span: 'full',
    },
    taxes: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Taxes',
      prefix: '$',
    },
    insurance: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Insurance',
      prefix: '$',
    },
    utilies: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Utilities',
      prefix: '$',
    },
    hoa: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'HOA',
      prefix: '$',
    },
    security: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Security',
      prefix: '$',
    },
    brokerFees: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Broker Fees / Property management costs',
      prefix: '$',
    },
    custom1: {
      inputType: 'custom',
      title: 'Custom',
      span: 'full',
    },
    invoiceTracking: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Invoice / Payment Tracking',
      prefix: '$',
    },
    constructionSpend: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Construction / Rehab spend',
      prefix: '$',
    },
    rentalIncome: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Rental Income',
      prefix: '$',
    },
    netRecovery: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Net Recovery',
      prefix: '$',
    },
    section3: {
      inputType: 'section',
      title: 'Sale Information',
      span: 'full',
    },
    saleDate: {
      inputType: 'text',
      type: 'date',
      title: 'Sale Date',
    },
    salesPrice: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Sales Price',
      prefix: '$',
    },
    netProceeds: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Net Proceeds',
      prefix: '$',
    },
  }
}
